import { Typography } from '@mui/material';

import { Typo } from 'Themes/typo';

type Props = {
  active: number;
  joined: number;
  expected: number;
};

export const ParticipantsInfo = ({ active, joined, expected }: Readonly<Props>) => (
  <Typography variant={Typo.title}>
    {active}/{joined}/{expected}
  </Typography>
);
